import { useCallback, useEffect, useState } from "react";
import { getNation } from "../../services/customerTouchPoint";

const useNation = () => {
    const [data1, setData1] = useState([]);

    const fetchData = useCallback(async () => {
        const res = await getNation();
        let newValue = [];
        if (res.data.code === "0000") {
            setData1(res.data.objectValue);
        }
    }, [setData1]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return [data1];
};

export default useNation;
